// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__QFviC","title":"Images45_title__2zGOH","images":"Images45_images__34Vsp"};